var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSantaWithTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 604,
    height: 544.136,
    viewBox: "0 0 604 544.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(-149.519 -139.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1208.721,1130.115c44.394,83.609,92.039,72.119,162.327,24.387l19.405,24.876c-65.163,69.519-158.6,96.989-229.09-21.786Z",
    transform: "translate(-682.306 -648.195)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M982.075,1147.43c-94.014-11.062-113.507,36.29-111.375,121.941l-30.7,3.037c-24.061-100.952,8.638-189.167,146.418-179.557Z",
    transform: "translate(-584.941 -636.944)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M853.42,1358.423c-2.938,5.264-6.759,12.119-10.7,18.8-6.306,10.712-12.23,20.731-10.832,21.909,1.5,1.268,6.431-4.087,12.334-10.245,4.5-4.7,9.7-10.049,13.4-13.7a36.734,36.734,0,0,0,.6,5.963c.357,1.583,2.127,1.542,4.091,1.4s3.811-.635,3.941-1.73c.286-2.337-1.223-15.444-2.268-22.8Z",
    transform: "translate(-584.622 -715.719)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M1483.6,1167.907c6.033-.06,13.88-.14,21.629-.04,12.432.158,24.072.332,24.4-1.468.354-1.932-6.739-3.556-15.017-5.626-6.308-1.576-13.537-3.433-18.543-4.834a36.759,36.759,0,0,0,4.878-3.481c1.2-1.092.284-2.611-.817-4.25-1.093-1.621-2.439-2.984-3.453-2.564-2.173.917-12.807,8.729-18.684,13.287Z",
    transform: "translate(-776.124 -652.772)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M738.092,974.693c18.383,21.726,85.343,79.511,189.977,10.613,2.676-1.762-6.129-29.262-6.129-29.262-56.583,20.889-115.536,32.577-168.509-2.7Z",
    transform: "translate(-556.89 -595.819)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1000.447,769.014c9.522,22.256,2.153,26.913-35.752-29.252-29.932-44.349-64.931-93.135-60.255-96.127,3.334-2.13,44.283,16.675,81.284,35.689,29.1,14.953,56.6,28.125,56.284,30.767-.332,2.732-8.075,1.844-12.507,1.14,16.611,14.4,49.769,30.339,75.78,42.389,20.146,9.333,36.526,16.725,36.333,18.672-.292,2.974-10.435,1.475-16.178.821,44.455,16.087,79.623,32.271,123.325,51.833,14.339,6.413,45.486,18.162,44.911,21.733-.75,4.646-17.54,3.433-23.692,3.586,32.783,19.212,49.016,27.438,47.752,31.034-1.2,3.431-22.812-6.5-57.311-21.9,31.323,28.788,61.643,50.311,59.644,55.31-3.636,9.085-23.252,4.951-72.028-15.326,31.124,26.806,51.484,43.743,50.472,48.466-1.349,6.3-31.923-6.13-81.783-30.915,46.608,46.772,62.5,66.005,60.024,68.773-3,3.346-37.594-18.349-67.742-42.641,10.51,21.358,22.667,46.459,16.73,49.475-13.873,7.054-98.415-97.6-146.455-144.087,6.29,18.383-.357,13.294-12.044-.6-17.349-20.639-53.127-67.359-66.793-78.838",
    transform: "translate(-606.053 -504.004)",
    fill: "#2a8b5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1194.593,870.5a12.86,12.86,0,0,1,5.807,1.407c4.576,2.4,7.47,7.9,6.36,12.957a10.52,10.52,0,0,1-7.924,7.862,14.508,14.508,0,0,1-5.6.108c-5.875-.29-11.148-5.525-10.983-11.611.157-5.66,5.678-10.472,11.737-10.716.171,0,.194-.007.606-.007m79.179-48.09a12.229,12.229,0,0,1,7.013,2.36c5.083,3.718,7.432,11.15,4.086,16.938-2.719,4.694-9.243,6.391-14.69,4.534a12.037,12.037,0,0,1-7.174-6.132s-.358-.6-.581-1.042a10.009,10.009,0,0,1,.731-10.111c2.412-3.477,5.749-6.506,10.492-6.547ZM1193.8,792.421a13.053,13.053,0,0,1,11.475,7.232c2.294,4.809,1.536,11.114-2.423,14.866-4.672,4.43-13.14,3.912-17.866-.958a12.572,12.572,0,0,1-3.141-11.738,12.327,12.327,0,0,1,6.279-7.916s.608-.349,1.131-.574a11.194,11.194,0,0,1,4.545-.911m-85.785,3.113c5.9.069,11.753,4.727,12.407,10.542.48,4.266-2.477,8.572-6.762,10.318-.042.023-.078.045-.119.065-4.779,2.362-11.017,0-13.93-5.015a11.243,11.243,0,0,1-.776-10.219,10.189,10.189,0,0,1,8.949-5.69Zm-104.949-61.256c6.836.051,13.691,6.4,12.058,13.99a9.265,9.265,0,0,1-5.427,6.708,13.077,13.077,0,0,1-2.773,1.17c-2.381.548-4.925-.364-7.067-1.307a10.581,10.581,0,0,1-5.709-5.618c-2.1-5.334.167-12.427,5.6-14.383a9.822,9.822,0,0,1,3.322-.559m-24.341-68.55a7.077,7.077,0,0,1,.761.05c6.337.611,11.316,7.771,9.791,13.958a9.161,9.161,0,0,1-6.016,6.569,12.024,12.024,0,0,1-6.235-.073c-3.841-.918-7.174-3.941-7.587-8.052-.1-1.047-.148-1.187-.166-1.569a9.722,9.722,0,0,1,.733-4.2s.229-.681.483-1.234a9.052,9.052,0,0,1,7.845-5.44c.257-.011.314-.009.391-.009",
    transform: "translate(-625.386 -510.6)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M997.9,782.858a84.213,84.213,0,0,0,23.638,3.66c13.6.015,24.851,2.341,15.619,8.66,31.648,7.241,47.111,35.884,51,74.362q-7.592-3.462-14.866-7.173c-16.813-20.88-35.879-44.368-45.03-52.051,8.641,20.2,3.37,25.9-26-15.191a104.992,104.992,0,0,1-4.362-12.266",
    transform: "translate(-633.871 -545.299)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1028.244,833.56c78.221-136.395,206.246-100.177,159.228-21.739-8.141-3.188-16.5-6.349-25.227-9.5,5.745.655,15.885,2.153,16.179-.821.118-1.205-6.085-4.484-15.6-9.015,1.647-29.175-44.241-22.454-102.629,56.014Z",
    transform: "translate(-642.862 -533.21)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1033.49,846.447c55.548,33.392,124.2,98.035,187.431,158.178L1014.116,1118.64C998.788,1037.916,988.191,971,986.589,890.892c-.452-22.726,6.352-41.527,18.3-48.147,7.761-4.3,18.084-2.616,28.6,3.7",
    transform: "translate(-630.513 -562.339)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1109.886,926.923c-1.224.784-2.437,1.57-3.666,2.35-8.554,5.411-17.193,10.718-25.579,16.357-15.426,10.371-30.115,21.615-45.93,31.581-10.274,6.47-21.049,12.439-31.347,18.379-3.1,1.782-6.223,3.543-9.378,5.242q.507,4.927,1.059,9.845c9.825-5.077,19.313-10.8,28.715-16.214,9.812-5.654,19.435-11.623,28.856-18.1,13.662-9.4,27.027-19.3,41.04-28.275,7.684-4.922,15.492-9.747,23.145-14.642l.451-.283q-3.7-3.154-7.366-6.24",
    transform: "translate(-632.712 -587.99)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M924.132,806.6c6.188,19.486-8.542,42.816-28.668,82.411-15.737,30.956-21.055,63.361-11.476,67.839,7,3.276,16.453-10.043,30.813-30.32,1.922,31.523,14.931,20.362,35.408-19.544-12.028,29.99-10.724,75.036,2.866,76.6,9.624,1.105,22.537-34.706,31.01-56.525-.37,16.495,4.054,42.653,15.778,41.091,23.414-3.109,38.705-104.175,13.783-145.588-10.1-16.778-26.827-31-52.3-42.26Z",
    transform: "translate(-598.703 -544.55)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M975.852,792.88l-28.926,20.167c-.317,6.9-1.546,15.231,5.479,19.922,5.7,3.8,9.577-4.393,17.253-9.639,5.544-3.789,12.141-2.551,18.042-7.921,9.7-8.823.329-20.091-11.848-22.528",
    transform: "translate(-618.683 -548.274)",
    fill: "#ffd3c0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M955.566,848.664c-.966-1.536-1.629-3.35-.33-4.159,1.832-1.14,5.294,1.709,6.564,2.918-2.071,1.568-4.031,2.3-6.234,1.241",
    transform: "translate(-621.016 -563.494)",
    fill: "#ffa195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1000.7,823.306c-3.819-7.759.372-14.349,6.223-7.371a12.113,12.113,0,0,1-3.64,5.43,17.208,17.208,0,0,1-2.583,1.941",
    transform: "translate(-634.267 -554.23)",
    fill: "#ffa195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1004.179,789.1l7.683,6.1c3.3-3.545,2.889-10.5.017-12.2-3.731-2.207-6.231,2.659-7.7,6.1",
    transform: "translate(-635.732 -545.184)",
    fill: "#ffd3c0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1005.23,841.155a7.411,7.411,0,0,1-1,5.079.449.449,0,0,0,.111.664.589.589,0,0,0,.8-.186,7.433,7.433,0,0,0,1.02-5.544c-.174-.9-.977-.428-.933-.013",
    transform: "translate(-635.719 -562.427)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M843.443,836.1s29.771-80.625,52.266-100.193c5.935-5.158,31.911-4.4,36.357,2.042,4.6,6.668,8.99,13.038,14.212,21.2L911.3,787.122l-10.232-11.765c-22.253,8.2-56.554,61.37-56.554,61.37Z",
    transform: "translate(-588.106 -530.386)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M929.981,789.954c-2.65,1.477-5.6,4.608-1.237,9.02,1.891,1.914,3.1,4.122,5.14,6.378,4.494,4.984,6.8,5.673,11.337.613a46.54,46.54,0,0,1,12.016-9.666,159.636,159.636,0,0,0,14.879-9.872c4.444-3.659,10.715-7.379,10.8-10.614.115-4.479-5.145-7.956-7.947-12.793a4.224,4.224,0,0,0-3.019-2.184c-1.589-.28-3.369.689-5.6,2.246-7.362,5.133-15.731,11.716-23.809,18.193l-7.748,5.655c-1.541.694-2.94,1.985-4.808,3.024",
    transform: "translate(-612.722 -538.761)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M820.3,884.206c4.891,10.049,26.927,4.845,22.756-5.9-4.6-11.846-26.553-1.895-22.756,5.9",
    transform: "translate(-581.119 -571.966)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M972.573,825.981c2.582-2.335,17.813,12.489,16.191,14.327-.484.544-1.738.222-2.912-.264.981,2.18,1.13,3.886.177,4.2-.888.285-2.263-.47-3.861-1.985.527,2.2.59,3.336-.473,3.619-2.988.789-11.048-18.152-9.122-19.892",
    transform: "translate(-626.28 -558.01)",
    fill: "#ffa195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M956.962,822.109a8.538,8.538,0,0,0-3.325,2.131,3.031,3.031,0,0,0-.807,2.574,1.979,1.979,0,0,0,1.238,1.867,3.348,3.348,0,0,0,2.663-.2,16.329,16.329,0,0,0,3.555-2.547,2.73,2.73,0,0,0,1.153-1.909,2.441,2.441,0,0,0-1.623-2.176,3.335,3.335,0,0,0-2.214.035c-.218.067-.43.145-.64.229",
    transform: "translate(-620.503 -556.802)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M980.154,806.832a6.853,6.853,0,0,0-2.734,3.236,2.52,2.52,0,0,0,.054,2.027,2,2,0,0,0,1.411,1.041,3.63,3.63,0,0,0,1.848-.25,11.475,11.475,0,0,0,4.224-3.168,3.137,3.137,0,0,0,1.025-1.829,2.258,2.258,0,0,0-1.8-2.169,5.366,5.366,0,0,0-4.027,1.111",
    transform: "translate(-627.749 -552.054)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M961.477,827.1a8.314,8.314,0,0,1,4.644,6.132,5.005,5.005,0,0,1-2.248,5.178,5.928,5.928,0,0,1-7.3-.465c-2.921-2.837-2.971-5.467-2.133-7.328,1.353-3.019,5.376-4.117,7.037-3.516m-1.762,11.44a5.38,5.38,0,0,0,5.556-2.9c.866-1.7-.185-4.794-2.1-6.7-2.267-2.267-4.523-1.219-6.6.255a4.537,4.537,0,0,0-1.54,5.173c.985,2.539,2.8,3.953,4.683,4.177",
    transform: "translate(-620.856 -558.365)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M975.456,819.317c-4.813-1.365-8.534,2.581-9.669,5.961l.765.525c2.206-4.66,5.307-6.462,9.423-5.745Z",
    transform: "translate(-624.358 -556.024)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M986.029,807.395a7.437,7.437,0,0,1,4.315,4.108,9.435,9.435,0,0,1,.807,2.406,5.642,5.642,0,0,1-2.666,5.721,5.83,5.83,0,0,1-7.521-.589c-3.348-3.07-3.889-7.12-1.29-9.456,2.179-1.96,4.162-2.749,6.356-2.19m-.187.764a4.183,4.183,0,0,0-2.959.383,9.745,9.745,0,0,0-2.667,1.67,4.174,4.174,0,0,0-1.223,2.691c-.237,1.852.337,3.492,2.548,5.671a5.758,5.758,0,0,0,3,1.289A4.863,4.863,0,0,0,988.07,819a4.4,4.4,0,0,0,2.437-4.836,11.266,11.266,0,0,0-1.376-3.454,6.012,6.012,0,0,0-3.289-2.549",
    transform: "translate(-627.986 -552.521)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M948.415,833.925c-5.068-2.652-13.265-4.969-14.3-2.466-.917,2.226,3.837,5.2,7.046,6.521.042-.261.087-.517.127-.774-2.727-1.324-7.239-3.734-6.34-5.376.863-1.576,6.651-.344,13.635,3.276Z",
    transform: "translate(-614.938 -559.384)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M991.645,799.773c.956-6.577,2.58-13.616,6.046-18.045,2.749-3.51,6.783-4.812,9.838-3.945,3.921,1.113,6.464,5.995,6.943,9.014.413,2.612.485,7.224-1.9,7.572a1.058,1.058,0,0,1-1.216-.942.758.758,0,0,1,.869-.959c.388.1.431.652.381,1.031,1.219-.975,1.264-4.179.9-6.534-.6-3.811-3.3-7.651-6.374-8.406-3.184-.777-6.122.231-8.82,3.693-3.087,3.948-4.79,10.409-5.842,18.028Z",
    transform: "translate(-632.017 -543.725)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M960.315,834.788c-.164-.636-.8-.359-.708.174.366,2.066,1.781,3.236,2.878,2.939,1-.277,1.683-1.74,1.072-5.044-.078-.435-.351-.53-.588-.438s-.255.38-.22.59c.3,1.7.393,3.713-.509,4.139-.535.256-1.469-.571-1.924-2.36",
    transform: "translate(-622.522 -559.978)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M985.151,816.058c-.16-.636-.8-.364-.706.172.365,2.063,1.778,3.236,2.877,2.938,1-.275,1.681-1.742,1.072-5.045-.082-.433-.351-.528-.588-.435s-.26.382-.22.59c.3,1.706.393,3.711-.507,4.139-.539.256-1.472-.573-1.929-2.36",
    transform: "translate(-629.882 -554.427)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M1482.786,1185.511c-4.132,3.684-5.918,2.657-9.129-1.55-2.768-3.618-4.789-7.344-9.968-13.891-3.92-4.957-9.9-9.222-6.654-12.319a35.527,35.527,0,0,1,6.275-4.378c1.907-1.14,3.2-2.173,5.091-1.695,2.132.536,4,4.251,6.243,6.39,3.956,5.076,6.792,9.365,8.411,11.1,5.766,6.179,7.531,10.125,3.922,12.818-1.432,1.138-2.833,2.314-4.19,3.528",
    transform: "translate(-769.636 -654.547)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M838.9,1349.856c-1.154-5.412.628-6.453,5.872-7.154,4.518-.607,8.754-.514,17.008-1.763,6.252-.948,12.922-4.025,14,.334a35.359,35.359,0,0,1,.682,7.625c.05,2.213.3,3.845-1.053,5.256-1.518,1.586-5.674,1.369-8.641,2.246-6.371.922-11.5,1.257-13.81,1.8-8.227,1.943-12.525,1.521-13.074-2.956q-.418-2.711-.985-5.387",
    transform: "translate(-586.662 -710.086)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M1325.934,1258.825a1.21,1.21,0,0,1,.077-1.785,1.572,1.572,0,0,1,1.894-.177c2.25,1.483,7.887,9.371-2.347,15.494a1.833,1.833,0,0,1-2.36-.134,1.227,1.227,0,0,1,.413-1.939c8.156-4.375,4.193-9.959,2.324-11.46",
    transform: "translate(-730.163 -685.678)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M1239.287,1064.943c1.334,2.42,2.229,4.537.826,7.183-2.273,4.293-7.426,5.4-14.524,8.659-11.345,5.213-22.081,10.342-32.521,16.414-20.889,12.138-41.329,26.2-68.246,39.317-17.288,8.43-37.455,21.627-60.033,34.047-10.728,5.9-22.033,11.465-33.386,17.3-2.174,1.119-5.5,3.716-8.624,3.327-1.208-.148-2.383-1.5-3.441-2.633-1.22-1.293-2.72-2.853-4.27-4.512-3.412-3.646-5.337-9.634.125-13.067,10.962-6.916,20.293-12.519,33.315-19.941,6.533-3.727,27.667-12.222,46.934-24.079,23.486-14.456,36.717-22.769,51.915-30.975,20.283-10.95,36.286-16.618,59.66-30.658,2.079-1.251,4.21-2.984,6.163-4.378,4.511-3.225,8.484-6.01,11.685-6.615,4.53-.853,9.548,1.775,14.423,10.606",
    transform: "translate(-637.981 -625.697)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M867.252,1186.528c.677-.446,1.293-.315,1.5.012.295.47-.05,1.454-.761,2-2.968,2.269-5.738,2.463-8.1,1.111-1.937-1.114-2.829-3.707-2.424-6.831.163-1.252.755-1.847,1.319-2.012.716-.211,1.332.38,1.335,1.477.009,2.389.492,4,1.475,4.81,1.17.958,3.071,1.136,5.654-.566",
    transform: "translate(-592.232 -663.203)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M730.071,949.809c-2.9-7.337-10.385-25.187-13.3-24.107-1.672.623.548,8.826,1.387,13.329-7.245-5.378-21.982-14.853-24.709-11.006-2.96,4.175,11.581,17.932,30.469,28.365Z",
    transform: "translate(-543.551 -587.611)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M749.078,942.956c-2.682-2.148-4.987-1.281-7.762,1.945-2.573,3.251-5.149,6.5-7.911,9.821-2.312,2.779-3.748,5.409-7.426,8.506-2.673,2.245-3.584,4.144-.495,7.043,2.44,2.287,3.023,2.873,7.125,6.337,2.776,2.346,4.892,1.55,6.934-1.236,3.306-4.509,4.785-6.809,7.684-9.781,4.1-4.2,5.393-6.819,8.22-9.953,2.809-3.123,2.826-6.3-.235-8.107a43.6,43.6,0,0,1-6.134-4.576",
    transform: "translate(-552.578 -592.392)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaWithTree);
export default __webpack_public_path__ + "static/media/santaWithTree.fffb1aa446472373ffe3be339cfc9756.svg";
export { ForwardRef as ReactComponent };